import { IconContainerProps, Rating, RatingProps, Typography } from "@mui/material";
import Icon from "@mdi/react";
import {
  mdiEmoticonAngryOutline,
  mdiEmoticonSadOutline,
  mdiEmoticonNeutralOutline,
  mdiEmoticonHappyOutline,
  mdiEmoticonExcitedOutline,
} from "@mdi/js";

import styles from "./radioGroupRating.module.scss";

export const feedbackLabels: { [index: string]: string } = {
  1: "Very Dissatisfied",
  2: "Dissatisfied",
  3: "Neutral",
  4: "Satisfied",
  5: "Very Satisfied",
};

const customIcons: {
  [index: number]: {
    icon: React.ReactElement;
    label: string;
  };
} = {
  1: {
    icon: <Icon className={styles.icon} path={mdiEmoticonAngryOutline} size={1.3} />,
    label: feedbackLabels[1],
  },
  2: {
    icon: <Icon className={styles.icon} path={mdiEmoticonSadOutline} size={1.3} />,
    label: feedbackLabels[2],
  },
  3: {
    icon: <Icon className={styles.icon} path={mdiEmoticonNeutralOutline} size={1.3} />,
    label: feedbackLabels[3],
  },
  4: {
    icon: <Icon className={styles.icon} path={mdiEmoticonHappyOutline} size={1.3} />,
    label: feedbackLabels[4],
  },
  5: {
    icon: <Icon className={styles.icon} path={mdiEmoticonExcitedOutline} size={1.3} />,
    label: feedbackLabels[5],
  },
};

function IconContainer(props: IconContainerProps) {
  const { value, ...other } = props;
  return <span {...other}>{customIcons[value].icon}</span>;
}

export interface RadioGroupRatingProps extends RatingProps {
  label?: string;
}

function RadioGroupRating(props: RadioGroupRatingProps) {
  const { label, ...rest } = props;

  return (
    <>
      {label ? (
        <Typography color='text.secondary' variant='body2' mb={1}>
          {label}
        </Typography>
      ) : null}
      <Rating
        getLabelText={(value: number) => feedbackLabels[value]}
        IconContainerComponent={IconContainer}
        {...rest}
      />
    </>
  );
}

export default RadioGroupRating;
